"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _server = require("react-dom/server");
var _createTextApi = _interopRequireDefault(require("./createTextApi"));
var _functionTree = require("function-tree");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// NOTE! This is only to be used on server side, to
// pass text to side effects like emails. Text should never
// be set in the state tree on the client

/**
 * TextProvider
 * @param languages - Languages resources
 * @param onMissingTextCallback - Provide a callback that will be called when a text translation is missing
 * @param options - Options for markdown (See markdown-to-jsx package)
 * @returns {wrappedT|Provider<{}>}
 * @constructor
 */
function TextProvider(languages, onMissingTextCallback, options) {
  return new _functionTree.Provider({
    create(language) {
      const languageData = languages[language || 'no'];
      const t = (0, _createTextApi.default)(languageData, onMissingTextCallback, options);

      // We wrap the result
      function wrappedT(...args) {
        const result = t(...args);
        if (result) {
          if (typeof result === 'string') {
            return result;
          }
          return (0, _server.renderToString)( /*#__PURE__*/(0, _react.createElement)('span', {}, result));
        }
        return null;
      }
      wrappedT.phrases = t.phrases;
      wrappedT.countries = t.countries;
      wrappedT.has = t.has;
      wrappedT.locale = t.locale;
      wrappedT.fullLocale = t.fullLocale;
      wrappedT.markdown = t.markdown;
      return wrappedT;
    }
  });
}
var _default = TextProvider;
exports.default = _default;
//# sourceMappingURL=textProvider.js.map